export default function useComma() {
    const numberComma = (num) => {
        const regex = /\B(?=(\d{3})+(?!\d))/g;
        if (!num) return 0;
        return num.toString().replace(regex, ',');
    };

    return numberComma;
}
